<template>
  <div class="pulses">
      <div class="pulses__heading">
          <a >
          <div class="pulses__heading-icon">
              <img src="assets/images/site-icons/wifi.svg" alt="">
          </div>
          </a>
      </div>
      <div class="pulses__items">
        <div class="pulses__items-animation-wrapper">
            <div @mouseover="scrollamount = 0" @mouseleave="scrollamount = 7" v-if="list.length > 0" :scrollamount="scrollamount" class="marquee" direction="right" width="100%">
                <div v-for="(item , key) in list" :key="key" class="pulse-item">
                    <b v-html="item.body"></b>
                </div>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name:'Pulses',
  data(){
    return{
      list:{},
      elements:{},
      scrollamount:7
    }
  },
  methods:{
    async getList(){
      await this.$axios.get(`lastNews`)
      .then(res => {
          this.list = res.data.data
      })
      .catch(err => {
      });
    },
    getPulseWidth()
    {
        var elements = this.$el.querySelectorAll('.pulse-item');
        var width = 0
        for(var i = 0; i < elements.length; i++){
            width +=  elements[i].offsetWidth;
        }
        document.documentElement.style.setProperty('--vari' , `${width}px`)
        document.documentElement.style.setProperty('--varisec' , `${width}s`)
    }
  },

  mounted(){
    this.getList()

  },

  updated(){
    this.getPulseWidth()

  }
}
</script>
<style>
.marquee{
    padding: 8px 0;
    display: flex;
    --vari : 0px;
    --varisec : 0s;
}
.pulses {
    width: 100%;
    display: flex;
    opacity: 1!important;
    background: #000000;
    position: relative;
    height: 65px;
    margin: 0;
    border-bottom: 5px solid #0a1146;
}
.pulses__heading {
    display: flex;
    align-items: center;
    color:#fff ;
    white-space: nowrap;
}
.pulses__heading:after {
    content: "";
    width: 1px;
    height: 25px;
    background: hsla(0,0%,100%,.3);
}
.pulses__heading a {
    display: flex;
    /* color: #fff; */
    margin:0 10px;
}
.pulses__items {
    flex: 1 1;
    display: flex;
    font-size: 16px;
    position: relative;
    overflow: hidden;
    /* color: #fff; */
    padding: 5px;
    align-items: center;
    white-space: nowrap;
}

.pulses__heading-icon {
    width: 22px;
    margin: 1px 4px;
}
.pulses__items-animation-wrapper {
    width: 100%;
    animation: infinite linear pulses calc(var(--varisec) / 80);
    padding-right: 100%;
}
.pulses__items-animation-wrapper:hover {
    cursor: grabbing;
    animation-play-state: paused;
}
.pulses__items-animation-wrapper .pulse-item {
    padding: 0 18px;
    color: #fcfcfc;
    display: inline-block; 
    border-left: .5px solid #4c7597;
}
.pulses__items-animation-wrapper .pulse-item p{
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    font-size: 16px;
}
/* .pulses__items-animation-wrapper .pulse-item:after {
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    height: 16px;
    background: hsla(0,0%,100%,.3);
    margin: 0 0 0 12px;
} */
@keyframes pulses {
    0% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    }
    100% {
        -webkit-transform: translate3d(calc(var(--vari) + 100%),0,0);
        transform: translate3d(calc(var(--vari) + 100%),0,0);
    }
}
</style>